import { render } from "./SecondaryButton.vue?vue&type=template&id=5d74ced8&scoped=true"
import script from "./SecondaryButton.vue?vue&type=script&lang=js"
export * from "./SecondaryButton.vue?vue&type=script&lang=js"

import "./SecondaryButton.vue?vue&type=style&index=0&id=5d74ced8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5d74ced8"

export default script